import { useTranslation } from '@lyearn/i18n';
import { AlertTriangleOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

const Disclaimer = ({ className }: { className?: string }) => {
  const { t } = useTranslation(['KnowledgeAsset']);
  return (
    <Stack
      alignItems="start"
      className={cn('!justify-self-start self-start', className)}
      gapX={8}
      justifyContent="center">
      <AlertTriangleOutline fillColorToken="icon-secondary" height={16} width={16} />
      <Typography variant="body-short-03">{t('KnowledgeAsset:Disclaimer')}</Typography>
    </Stack>
  );
};

export default Disclaimer;
